import { h } from 'vue';
import { RouterLink } from 'vue-router';
import type { BuiTblColumn } from '@/components/bui/organisms/Tbl/types';
import TblRowActions from '@/components/bui/molecules/TblRowActions/TblRowActions.vue';

const locationsColumns: BuiTblColumn[] = [
  {
    key: 'name',
    kind: 'name',
    label: 'Name',
    grow: true,
    minWidth: 180,
    selectable: true,
    sortable: true,
    sortKey: 'name',
    render: ({ item }) =>
      h('div', { class: 'bui-cell-name' }, [
        h(
          RouterLink,
          { to: `/locations/edit/${item.id}`, class: 'title-link', onClick: (e: MouseEvent) => e.stopPropagation() },
          () => item.name,
        ),
        h('div', { class: 'bui-cell-sub' }, item.assetType ? `${item.assetType[0].toUpperCase()}${item.assetType.substring(1)}` : ''),
      ]),
  },
  {
    key: 'businessUnit',
    kind: 'text',
    label: 'Business Unit',
    grow: true,
    minWidth: 120,
    render: ({ item }) => item.businessUnitNumber || '',
  },
  {
    key: 'city',
    kind: 'text',
    label: 'City',
    grow: true,
    minWidth: 100,
    render: ({ item }) => item.city || '',
  },
  {
    key: 'state',
    kind: 'text',
    label: 'State',
    width: 90,
    render: ({ item }) => item.state || '',
  },
  {
    key: 'country',
    kind: 'text',
    label: 'Country',
    grow: true,
    minWidth: 110,
    render: ({ item }) => item.country || '',
  },
  {
    key: 'region',
    kind: 'text',
    label: 'Region',
    grow: true,
    minWidth: 110,
    render: ({ item }) => item.region || '',
  },
  {
    key: 'actions',
    kind: 'actions',
    label: 'Actions',
    width: 100,
    render: ({ item }) => h(TblRowActions, { item }),
  },
];

export default locationsColumns;
